import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useDisableTourMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const queryClient = useQueryClient()

  const setDisableTour = async () => {
    const url = encodeURI(`${env.apiUrl}/userInfo`)
    const body = { enableTour: false }
    const response = await securedFetch(url, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: setDisableTour,
    onMutate: () => {
      queryClient.cancelQueries({ queryKey: ['user'] })
      queryClient.setQueryData(['user'], (user) => ({
        ...(user ?? {}),
        enableTour: false
      }))
    },
    onError: (error) => handleError(error, 'Error updating tour'),
    onSettled: () => queryClient.invalidateQueries({ queryKey: ['user'] })
  })
}

export { useDisableTourMutation }
